// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__xDZWc","list":"styles_list__2sc4S"};